import { optimizeImage } from './file';
import deserialize from './getroPropertyMapper';

export const transformCompanyData = (response) => {
  const serializedData = deserialize(response);
  return {
    ...serializedData,
    logoUrl: optimizeImage(serializedData?.logoUrl),
    locations: serializedData?.allLocations,
  };
};

export const mapOrganizationHeadCount = (headCount) => {
  switch (headCount) {
    case '1-10':
      return 1;
    case '11-50':
      return 2;
    case '51-200':
      return 3;
    case '201-1000':
      return 4;
    case '10001-5000':
      return 5;
    default:
      return 6;
  }
};

export const reverseMapOrganizationHeadCount = (value) => {
  switch (value) {
    case 1:
      return '1 - 10';
    case 2:
      return '11 - 50';
    case 3:
      return '51 - 200';
    case 4:
      return '201 - 1000';
    case 5:
      return '1001 - 5000';
    default:
      return '5001+';
  }
};

export const mapCompanyHeadCountIntervals = (data, format = false) => {
  const value = parseInt(data, 10);
  let result;

  switch (true) {
    case value < 11:
      result = '1 - 10';
      break;
    case value < 51:
      result = '11 - 50';
      break;
    case value < 201:
      result = '51 - 200';
      break;
    case value < 501:
      result = '201 - 500';
      break;
    case value < 5001:
      result = '1001 - 5000';
      break;
    default:
      result = '50001+';
  }

  if (format) {
    return result.replaceAll(' ', '');
  }

  return result;
};

export const mapApproxEmployees = (data) => {
  const value = parseInt(data, 10);
  return mapOrganizationHeadCount(mapCompanyHeadCountIntervals(value, true));
};

export const getCompanySize = (headCount) =>
  typeof headCount === 'string' ? mapOrganizationHeadCount(headCount) : headCount;

export const getCompanySizeLabel = (headCount) =>
  typeof headCount === 'number' ? reverseMapOrganizationHeadCount(headCount) : headCount?.split('-').join(' - ');
